import React, { FC } from 'react';
import { IconProps } from 'components/UI/Icon/types';

export const Trash: FC<IconProps> = ({ height, width, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4407 6.99999H7.02668C7.02448 7 7.02229 7 7.0201 7C7.01888 7 7.01766 7 7.01643 6.99999H3.75377C3.35176 6.99999 3 6.67336 3 6.24622C3 5.81909 3.32663 5.49245 3.75377 5.49245H7.0241C7.44959 5.49058 7.82436 5.18962 7.8995 4.76382L8.15075 3.55779C8.40201 2.62814 9.20603 2 10.1106 2H14.3317C15.2613 2 16.0653 2.62814 16.2915 3.50754L16.5427 4.76382C16.6179 5.18962 16.9926 5.49058 17.4181 5.49245H20.6884C21.0905 5.49245 21.4422 5.81909 21.4422 6.24622C21.4422 6.67336 21.1156 6.99999 20.6884 6.99999H17.4509C17.4497 7 17.4485 7 17.4472 7C17.445 7 17.4429 7 17.4407 6.99999ZM9.26085 5.49245H15.2297C15.1771 5.35642 15.1369 5.21369 15.1106 5.06533L14.8593 3.8593C14.809 3.68342 14.608 3.50754 14.3568 3.50754H10.1106C9.8593 3.50754 9.65829 3.65829 9.60804 3.90955L9.38191 5.09045C9.35346 5.22956 9.31267 5.36389 9.26085 5.49245ZM12.2211 22C10.8643 22 9.55778 21.9749 8.27637 21.9497C6.59296 21.9246 5.43718 20.8442 5.2613 19.1105C5.04186 17.22 4.73169 13.5717 4.54413 11.3654C4.45251 10.2878 4.39015 9.55418 4.3819 9.53768C4.35677 9.13567 4.65828 8.75879 5.06029 8.73366C5.4623 8.70854 5.83919 9.01005 5.86431 9.41206C5.86431 9.48743 6.41708 16.1457 6.71858 18.9598C6.81909 19.9397 7.34673 20.4422 8.27637 20.4422C10.7638 20.4925 13.3015 20.4925 16.0653 20.4422C17.0452 20.4171 17.5729 19.9397 17.6985 18.9347C18 16.1457 18.5528 9.46231 18.5528 9.38693C18.5779 8.98492 18.9548 8.68341 19.3568 8.70854C19.7588 8.73366 20.0854 9.11055 20.0352 9.51256C20.0352 9.58794 19.4824 16.2965 19.1809 19.1105C18.9799 20.8442 17.8241 21.9246 16.0904 21.9497L15.9425 21.9525L15.9422 21.9525C14.6636 21.9767 13.4307 22 12.2211 22Z"
        fill={fill}
      />
    </svg>
  );
};

Trash.displayName = 'Trash';

Trash.defaultProps = { height: '16', width: '16' };
